import {
  LearningUnit,
  Lesson,
  ContentMetaData,
  Lessons,
  Course,
  Courses,
  CourseLesson,
  SuperCourse,
  SuperCourses,
  FeatureContentType,
  FeatureContent,
  FeatureContentData
} from '@tdwb/core';
// eslint-disable-next-line td-wb-rules/cross-lazyload-module-import-rule
import { LearnProgress, LearnSort, LearnLike } from '@tdwb/lazy/learn';

export enum LearnOnDemandTab {
  COURSES = 'courses',
  LESSONS = 'lessons'
}

export enum LearnWelcomeTab {
  OVERVIEW = 'learnOverview',
  PREFERENCES = 'learnPreferences'
}

export enum LearnEventType {
  MASTER_CLASS = 'MASTER_CLASS',
  WEBINAR = 'WEBINAR'
}

export enum LearnEventTab {
  PAST_EVENTS = 'pastEvents',
  UPCOMING_EVENTS = 'upcomingEvents'
}

export interface FilterOccurrenceData {
  filter: string;
  occurrences: number;
}

export {
  ContentMetaData,
  LearningUnit,
  Lesson,
  Lessons,
  Course,
  Courses,
  CourseLesson,
  SuperCourse,
  SuperCourses,
  FeatureContentType,
  FeatureContent,
  FeatureContentData,
  LearnProgress,
  LearnSort,
  LearnLike
};
